module.exports = __webpack_public_path__ + "img/courtcases.461c1ff5.svg";